<!--Author : Ganesh Lawand for recent activities -->
<div ng-controller="RecentActivitiesCtrl" style="font-size: 12px;">
  <div class="row flexCenter">
    <div class="flexSpaceBtn">
      <div class="col-sm-12" style="display: inline-flex;">
        <div class="col-sm-6">
          <label id="fromDate" class="col-sm-1">From : </label>&nbsp;
          <input class="filter col-sm-2" id="fromDate" type="date" [(ngModel)]="fromDate" [max]="toDate" (change)="doFilter()"
            style="font-size:12px;width: 130px;margin-right: 10px;" />
          <label for="toDate" style="margin-left:10px;">{{"To : " | translate}}</label>&nbsp;
          <input class="filter col-sm-2" id="toDate" type="date" [(ngModel)]="toDate" [min]="fromDate" [max]="toDate"
            (change)="doFilter()" style="font-size:12px;width: 130px;margin-right: 10px;" />
          <button class="btn btn-sm btn-primary col-sm-3" id="quickFiltersBtn" style="font-size: 12px;display: inline-block;" (click)="toggleFilters()">
            {{"Quick Filters" | translate}}
          </button>
        </div>
        <div class="col-sm-5">
          @if (showFilters) {
            <button class="btn btn-sm btn-primary col-sm-2" id="7Days" style="font-size: 12px;" (click)="dateFilter(7)">{{"7 Days" | translate}}</button>
          }
          @if (showFilters) {
            <button class="btn btn-sm btn-primary col-sm-2" id="1Month" style="font-size: 12px;" (click)="dateFilter(30)">{{"1 Month" | translate}}</button>
          }
          @if (showFilters) {
            <button class="btn btn-sm btn-primary col-sm-2" id="6Months" style="font-size: 12px;" (click)="dateFilter(180)">{{"6 Months" | translate}}</button>
          }
          @if (showFilters) {
            <button class="btn btn-sm btn-primary col-sm-2" id="1Year" style="font-size: 12px;" (click)="dateFilter(365)">{{"1 Year" | translate}}</button>
          }
        </div>
        <!-- <div *ngIf="showFilters">
      </div> -->




    </div>
  </div>
</div>
</div>
<!-- <div class="container mt-5"> -->
<!-- </div> -->
@if (showContent) {
  <div class="mt-3" style="margin-left: 43%;">
    <button (click)="showActivities()" class="btn btn-secondary">{{"Activities" | translate}}</button>
    <button (click)="showVersions()" class="btn btn-secondary">{{"Versions" | translate}}</button>
  </div>
}
<div class="row">
  <div class="col-6 col-md-6">
    <div id="activities"></div>
  </div>
  <div class="col-6 col-md-6">
    <div id="versions"></div>
  </div>

  <div class="row">
    <div style="height: 35em; overflow: auto; scrollbar-width: thin;">
      <table class="table table-bordered table-striped" style="color:black;font-weight:bold; text-align: center;">
        <thead style="background-color:rgb(1, 42, 110);color:white; top: 0vh; position: sticky;">
          <tr>
            <th>{{"Acquire Time" | translate}}</th>
            <th>{{"Release Time" | translate}}</th>
            <th>{{"Device Name" | translate}}</th>
            <th>{{"Serial No" | translate}}</th>
            <th>{{"Version" | translate}}</th>
            <th>{{"Status" | translate}}</th>
            <th>{{"Activity" | translate}}</th>
          </tr>
        </thead>
        <tbody>
          @for (data of recentActivities; track data) {
            <tr>
              <td>{{data.aquireTime}}</td>
              <td>{{data.releaseTime}}</td>
              <td> <i class="fa" style="color:cornflowerblue;">&#xf10b;&nbsp;</i>{{data.model}}</td>
              <td>{{data.serialNo}}</td>
              <td>
                @if (data.platform==='iOS') {
                  <span><i class="fa" style="color:#47d74b">&#xf179;&nbsp;</i>{{data.platform}}
                {{data.version}}</span>
              }
              @if (data.platform==='Android') {
                <span>
                  <i class="fa" style="color:#47d75b;">&#xf17b;&nbsp;</i>{{data.platform}} {{data.version}}</span>
                }
              </td>
              <td ng-style="{color:data.status=='Active'?'green':'black'}">{{data.status}}</td>
              <td>{{data.Activity}}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
<ng-template #alerttemplate let-modal>
  <div class="modal-body text-center">
    <p class="alert-message" style="overflow-wrap: break-word;">{{msg | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="Ok()">{{"OK" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>